import React from 'react';
import styles from './ContactUsText.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const ContactUsText = ({className, text, mailLink}) => {
  return (
    <p className={`${cx('ContactUsText')} ${className}`}>
      {`${text} `}
      <a className={cx('ContactUsText', 'ContactUsText__email')} href={`mailto:${mailLink}`}>
        {mailLink}
      </a>
    </p>
  );
};

export default ContactUsText;